import { IReleaseNote } from './index'
import { IPaginatedRequest } from '../../request'

export const listReleaseNotes = (params: IPaginatedRequest) => ({
  method: 'GET',
  url: '/modules/release-notes',
  params
})

export const getReleaseNote = (UUID: string) => ({
  method: 'GET',
  url: `/modules/release-notes/${UUID}`
})

export const createReleaseNote = (data: Partial<IReleaseNote>) => ({
  method: 'POST',
  url: '/modules/release-notes',
  data
})

export const updateReleaseNote = (UUID: string, data: Partial<IReleaseNote>) => ({
  method: 'PUT',
  url: `/modules/release-notes/${UUID}`,
  data
})

export const deleteReleaseNote = (UUID: string, dryRun?: boolean) => ({
  method: 'DELETE',
  url: `/modules/release-notes/${UUID}`,
  params: {
    dryRun
  }
})
